var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-print-word",on:{"click":_vm.printWordStatistic}},[_vm._v(_vm._s(_vm.$t("Печать в Word")))])
}
var staticRenderFns = []

export { render, staticRenderFns }